import { SxProps, Theme } from "@mui/material";
import colorsConstants from "src/app/constants/colors.constants";

const styles = {
  parent: {
    backgroundColor: colorsConstants.mainContentBackgroundColor,
    flex: 1,
    display: "flex",
    height: "100vh",
  },
  drawerAwareContainer: {
    display: "flex",
    flex: 1,
    flexDirection: "column",
    padding: "24px",
  },
  titleGrid: {
    display: "flex",
    alignItems: "center",
    gap: 2,
    width: "90%",
  },
  titleText: {
    color: colorsConstants.primaryText,
    fontSize: 24,
    textAlign: "center",
    flex: 1,
    marginLeft: "24px",
  },
  tabsContainer: {
    borderRadius: "10px",
    border: "1px solid rgba(0, 0, 0, 0.1)",
    overflow: "hidden",
    backgroundColor: "transparent",
    boxShadow: "none",
  },
  selectedTab: {
    p: { xs: 2, sm: 3 },
  },
  selectedTabContent: {
    p: 2,
    borderRadius: 2,
    border: "1px solid rgba(0, 0, 0, 0.08)",
    backgroundColor: colorsConstants.drawerListItemContainerSelected,
    height: "100%",
    boxShadow: "none",
  },
  selectedTabText: {
    color: colorsConstants.primaryText,
    fontWeight: 700,
    mb: 2,
  },
  requestCard: {
    p: 2,
    borderRadius: 2,
    border: "1px solid rgba(0, 0, 0, 0.08)",
    backgroundColor: colorsConstants.drawerListItemContainerSelected,
    boxShadow: "none",
  },
  requestCardMoreTime: {
    border: "2px solid rgba(255, 152, 0, 0.5)",
  },
  requestTitleRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "wrap",
    gap: 1,
    mb: 1,
  },
  requestTitleText: {
    color: colorsConstants.primaryText,
    fontWeight: 700,
  },
  requestMetaText: {
    color: colorsConstants.primaryText,
    mb: 0.5,
    opacity: 0.85,
  },
  requestDescriptionText: {
    color: colorsConstants.primaryText,
    mb: 1.5,
    opacity: 0.75,
  },
  requestActionsRow: {
    display: "flex",
    gap: 1,
    flexWrap: "wrap",
    mt: 1,
  },
  searchingLoader: {
    display: "flex",
    justifyContent: "center",
    py: 4,
  },
  noRequestsText: {
    color: colorsConstants.primaryText,
    opacity: 0.7,
  },
  selectorContainer: {
    width: "100%",
  },
  selectorPaper: {
    p: 2,
    borderRadius: 2,
    border: "1px solid rgba(0, 0, 0, 0.08)",
    backgroundColor: colorsConstants.drawerListItemContainerSelected,
    boxShadow: "none",
  },
  modalActionsContainer: {
    display: "flex",
    flex: 1,
    justifyContent: "space-evenly",
    mb: 1.5,
  },
  modalCancelButton: {
    color: colorsConstants.error,
  },
  modalTextField: {
    mt: 2,
    mb: 2,
    backgroundColor: "transparent",
  },
  chipRow: {
    display: "flex",
    gap: 1,
    flexWrap: "wrap",
    mb: 1,
  },
} satisfies Record<string, SxProps<Theme>>;

export default styles;
